/**
 * Serviceplan MAKEOS
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface CreateClientsConfigurationDto { 
    /**
     * Company ID for the client
     */
    client: string;
    /**
     * Use all brands of this client
     */
    allBrands?: boolean;
    /**
     * Brand IDs to be used for this client
     */
    brands?: Array<string>;
}

